import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  test: any;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  redirecttoHome() {
    this.router.navigate(['/home']);
  }

  navigatecontact(){
    this.router.navigate(['contact'])
  }
  

}
